import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { toggleModal } from '../../../app/reducer';
import Modal from '../../../common/securities-firms';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from '../../../app/commonReducer';

class BuySellButton extends React.Component {
  div = document.createElement('div');

  componentDidMount() {
    document.body.appendChild(this.div);
  }

  componentWillUnmount() {
    document.body.removeChild(this.div);
  }

  handleBuyClick = () => {
    const { code } = this.props;
    window.parent.postMessage(
      {
        action: 'BUY',
        data: {
          ticker: code,
        },
      },
      '*',
    );
  };

  handleSellClick = () => {
    const { code } = this.props;
    window.parent.postMessage(
      {
        action: 'SELL',
        data: {
          ticker: code,
        },
      },
      '*',
    );
  };

  render() {
    const { toggleModal } = this.props;
    return (
      <div className="group-button d-flex align-items-center justify-content-between flex-row mr-3">
        {ReactDOM.createPortal(<Modal />, this.div)}
        <div
          className="group-button--buy"
          onClick={this.handleBuyClick}
          style={{ marginRight: 4 }}
        >
          {I18n.t('priceDepth.groupButton.buy')}
        </div>
        <div className="group-button--sell" onClick={this.handleSellClick}>
          {I18n.t('priceDepth.groupButton.sell')}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    i18n: state.i18n,
    listOrganizationByOrganCode:
      state[COMMON_REDUCER_NAME].listOrganizationByOrganCode,
  };
};

const mapDispatchToProps = {
  toggleModal,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BuySellButton);
